module.exports = __webpack_public_path__ + "static/media/step2-poster.9aeae4f3.png";